import { EventObject, Typestate } from 'xstate';
import { ApplyRequestMachineContext, ApplyResponseMachineContext } from './shared/context/applyMachineContext';
import { CustomerSearchRequestMachineContext, CustomerSearchResponseMachineContext } from './shared/context/customerSearchMachineContext';
import { OrderIdMachineContext } from './shared/context/orderIdMachineContext';
import { OrderMachineContext } from './shared/context/orderMachineContext';
import { RoleMachineContext } from './shared/context/roleMachineContext';

// Context Types
export interface OtbMachineContext
  extends RoleMachineContext,
    OrderIdMachineContext,
    OrderMachineContext,
    ApplyRequestMachineContext,
    ApplyResponseMachineContext,
    CustomerSearchRequestMachineContext,
    CustomerSearchResponseMachineContext {
  initialState?: string;

  isLast4Different: boolean;

  autoVerticalError?: boolean;
}

// State Types
export enum OtbStates {
  InitialState = 'InitialState',
  Approval = 'Approval',
  LastFour = 'LastFour',
  NewApplication = 'NewApplication',
  ExistingApplication = 'ExistingApplication',
  ApprovalConfirmation = 'ApprovalConfirmation',
  PrepareOtbContext = 'PrepareOtbContext',
  Ineligible = 'Ineligible',
  LTOIneligible = 'LTOIneligible',
}

export interface OtbMachineStatesSchema {
  [OtbStates.InitialState]: {};
  [OtbStates.Approval]: {};
  [OtbStates.LastFour]: {};
  [OtbStates.NewApplication]: {};
  [OtbStates.ExistingApplication]: {};
  [OtbStates.ApprovalConfirmation]: {};
  [OtbStates.PrepareOtbContext]: {
    preparing: {};
    callingApply: {};
    callingQueryOrder: {};
    select: {};
  };
  [OtbStates.Ineligible]: {};
  [OtbStates.LTOIneligible]: {};
}

export interface OtbMachineStates extends Typestate<OtbMachineContext> {
  type: OtbMachineStatesSchema;
}

// Event Types
export enum OtbEvents {
  OTBType = 'OTBType',
  IncorrectSSN = 'IncorrectSSN',
  Next = 'Next',
  NEXT = 'NEXT',
  BACK = 'BACK',

  NotRecognized = 'NotRecognized',
  Last4SSN = 'Last4SSN',
  InternalError = 'InternalError',
  Apply = 'Apply',
  LeaseRestrictedApplyErr = 'LeaseRestrictedApplyErr',
  CartValidationApplyErr = 'CartValidationApplyErr',
  FatalApplyErr = 'FatalApplyErr',

  TRACK = 'TRACK',
  PAGE = 'PAGE',
  IDENTIFY = 'IDENTIFY',
}

type OtbEventsTypeSchema =
  | OtbEvents.OTBType
  | OtbEvents.IncorrectSSN
  | OtbEvents.NEXT
  | OtbEvents.BACK
  | OtbEvents.NotRecognized
  | OtbEvents.InternalError
  | OtbEvents.Apply
  | OtbEvents.Last4SSN
  | OtbEvents.LeaseRestrictedApplyErr
  | OtbEvents.CartValidationApplyErr
  | OtbEvents.FatalApplyErr
  | OtbEvents.TRACK
  | OtbEvents.PAGE
  | OtbEvents.IDENTIFY;

export interface OtbMachineEvents extends EventObject {
  type: OtbEventsTypeSchema;
  data?: any;
}

// Guard Types
export enum OtbGuardsType {
  EXISTING_CUSTOMER_FOUND = 'ExistingCustomerFound',
  CUSTOMER_OTB = 'CustomerOTB',
  CUSTOMER_DECLINED = 'CustomerDeclined',
  CUSTOMER_NOT_FOUND = 'CustomerNotFound',
  SKIP_TO_PAGE = 'SkipToPage',
  NORMAL_INITIAL = 'NormalInitial',
  TRACK = 'TRACK',
  PAGE = 'PAGE',
  IDENTIFY = 'IDENTIFY',
}
type OtbGuardsTypeSchema =
  | OtbGuardsType.EXISTING_CUSTOMER_FOUND
  | OtbGuardsType.CUSTOMER_OTB
  | OtbGuardsType.CUSTOMER_NOT_FOUND
  | OtbGuardsType.CUSTOMER_DECLINED
  | OtbGuardsType.NORMAL_INITIAL
  | OtbGuardsType.SKIP_TO_PAGE
  | OtbGuardsType.TRACK
  | OtbGuardsType.PAGE
  | OtbGuardsType.IDENTIFY;

export interface OtbMachineGuards extends EventObject {
  type: OtbGuardsTypeSchema;
}
